import { useEffect } from 'react';

import { VARIANT_IDENTIFIER } from '@/modules/experiments/config';
import { useExperiments } from '@/modules/experiments/useExperiments';

export function useSavedSearchExperiment(hasSearched: boolean) {
  const [{ web_8983_saved_search_fake_door }, bucket] = useExperiments(
    ['web_8983_saved_search_fake_door'],
    { deferred: true }
  );

  useEffect(() => {
    if (hasSearched) {
      bucket();
    }
  }, [hasSearched, bucket]);

  return hasSearched && web_8983_saved_search_fake_door === VARIANT_IDENTIFIER;
}
